export default {
  activityLogData: {},
  activityLogDataInvoices: {},
  activityLogDataCustomers: {},
  page: 0,
  pagesCount: 0,
  activityCount: 0,
};
